module.exports = __webpack_public_path__ + "img/masterblaster2.372c099d.jpg";